import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { DocPickerComponent } from "../doc-picker/doc-picker.component";

@Injectable({
    providedIn: 'root'
})
export class DocPickerService {

    constructor(private dialog: MatDialog) {
        this.dialog = dialog;
    }

    public showDocPicker(fromGuid: string, docType: string): Observable<any> {
        const dialogRef: MatDialogRef<DocPickerComponent> = this.dialog.open(DocPickerComponent);
        dialogRef.componentInstance.dialogRef = dialogRef;
        dialogRef.componentInstance.fromGuid = fromGuid;
        dialogRef.componentInstance.docType = docType;
        return dialogRef.afterClosed();
    }
}